import { defineStore } from 'pinia'

import {
  RemoteProviderConnectionEstablishedEvent,
  RemoteProviderConnectionExpirationEvent,
  RemoteProviderEventConnectionType,
} from '@/shared/apis/bgnotifications'

interface ProviderState {
  events: RemoteProviderEventConnectionType[]
}

export const useProviderStore = defineStore('provider', {
  state: () =>
    ({
      events: [],
    }) as ProviderState,
  getters: {
    currentEvent: state => {
      return state.events.at(-1)
    },
  },
  actions: {
    async initialize() {
      this.events = []
    },
    async handleConnectionEstablished(
      event: RemoteProviderConnectionEstablishedEvent
    ) {
      this.events.push(event)
    },
    async handleConnectionExpired(
      event: RemoteProviderConnectionExpirationEvent
    ) {
      this.events.push(event)
    },
    async handleConnectionClosed() {
      this.events = []
    },
    async processConnectionEvent(eventId: string) {
      this.events = this.events.filter(e => e.id === eventId)
    },
  },
})
